import { ICreateChatMessage } from './types/chat'
import { ICreateUser, IEditNick, IEditUser, ILogin } from './types/user'
import { plainAxios, securedAxios } from '../axios'
import { ICreateGame, IGame } from './types/game'
import { IUpdateHelp } from './types/document'
import {
  ICreateCharacter,
  IDiceRoll,
  IDmgRoll,
  ISkillRoll,
  IStatRoll,
  IStatUpdate,
} from './types/character'
import { ICreateAction } from './types/action'
import { IDumpItem, IEquipItem, IGiveItem, IItem, IUseItem } from './types/item'
import { ISpell } from './types/spell'

export const mutationLogin = (cred: ILogin) => plainAxios.post('/sessions/login', cred)
export const mutationLogout = () => securedAxios.delete('/sessions/logout')

export const mutationCreateUser = async (newUser: ICreateUser) =>
  securedAxios.post(`/users`, newUser)
export const mutationEditUser = async (id: number, data: IEditUser) =>
  securedAxios.put(`/users/${id}`, data)
export const mutationEditUserNick = async (id: number, data: IEditNick) =>
  securedAxios.put(`/users/${id}/change_nick`, data)
export const mutationDeleteUser = async (id: number) => securedAxios.delete(`/users/${id}`)
export const mutationCreateChatMessage = async (newMessage: ICreateChatMessage) =>
  securedAxios.post(`/chat_messages`, newMessage)
export const mutationDeleteChatEntry = async (id: number) =>
  securedAxios.delete(`/chat_messages/${id}`)
export const mutationCreateGame = async (newGame: ICreateGame) =>
  securedAxios.post(`/games`, newGame)
export const mutationDeleteGame = async (slug: string) => securedAxios.delete(`/games/${slug}`)
export const mutationUpdateHelp = async (help: IUpdateHelp) =>
  securedAxios.post(`/update_help`, help)
export const mutationPlayerCreateCharacter = async (char: ICreateCharacter) =>
  securedAxios.post(`/characters/player_create`, char)
export const mutationCreateCharacter = async (char: ICreateCharacter) =>
  securedAxios.post(`/characters`, char)
export const mutationUpdateCharacterStat = async (update: IStatUpdate) =>
  securedAxios.put(`/characters/${update.character_id}/update_stat`, update)
export const mutationUpdateCharacterSkill = async (update: IStatUpdate) =>
  securedAxios.put(`/characters/${update.character_id}/update_skill`, update)
export const mutationUpdateCharacterWeaponProf = async (update: IStatUpdate) =>
  securedAxios.put(`/characters/${update.character_id}/update_weapon_prof`, update)
export const mutationDeleteCharacter = async (char_id: number) =>
  securedAxios.delete(`/characters/${char_id}`)
export const mutationStatRoll = async (char_id: number, roll: IStatRoll) =>
  securedAxios.post(`/characters/${char_id}/stat_roll`, roll)
export const mutationDiceRoll = async (char_id: number, roll: IDiceRoll) =>
  securedAxios.post(`/characters/${char_id}/dice_roll`, roll)
export const mutationSkillRoll = async (char_id: number, roll: ISkillRoll) =>
  securedAxios.post(`/characters/${char_id}/skill_roll`, roll)
export const mutationJoinGame = async (char_id: number, game_id: number) =>
  securedAxios.post(`/characters/${char_id}/join_game`, { game_id: game_id })
export const mutationNpcJoinGame = async (char_id: number, game_id: number) =>
  securedAxios.post(`/characters/${char_id}/npc_join_game`, { game_id: game_id })
export const mutationLeaveGame = async (char_id: number, game_id: number) =>
  securedAxios.post(`/characters/${char_id}/leave_game`, { game_id: game_id })
export const mutationUpdateCharacterNotes = async (char_id: number, notes: string) =>
  securedAxios.put(`/characters/${char_id}/update_notes`, { notes: notes })
export const mutationCreateAction = async (action: ICreateAction) =>
  securedAxios.post(`/actions`, action)
export const mutationRejectAction = async (action_id: number) =>
  securedAxios.post(`/actions/${action_id}/reject`)
export const mutationApproveAction = async (action_id: number) =>
  securedAxios.post(`/actions/${action_id}/approve`)
export const mutationCreateItem = async (newItem: IItem) => securedAxios.post(`/items`, newItem)
export const mutationEditItem = async (id: number, item: IItem) =>
  securedAxios.put(`/items/${id}`, item)
export const mutationDeleteItem = async (id: number) => securedAxios.delete(`/items/${id}`)
export const mutationDeleteSpell = async (id: number) => securedAxios.delete(`/spells/${id}`)
export const mutationEditSpell = async (id: number, spell: ISpell) =>
  securedAxios.put(`/spells/${id}`, spell)
export const mutationCreateSpell = async (newSpell: ISpell) =>
  securedAxios.post(`/spells`, newSpell)
export const mutationGiveItem = async (give: IGiveItem) =>
  securedAxios.post(`/characters/${give.character_id}/items`, give)
export const mutationDeleteCharacterItem = async (dump: IDumpItem) =>
  securedAxios.delete(
    `/characters/${dump.character_id}/items/${dump.character_item_id}?game_id=${dump.game_id}`
  )
export const mutationEquipCharacterItem = async (item: IEquipItem) =>
  securedAxios.post(
    `/characters/${item.character_id}/items/${item.character_item_id}/equip?game_id=${item.game_id}`
  )
export const mutationUnequipCharacterItem = async (item: IEquipItem) =>
  securedAxios.post(
    `/characters/${item.character_id}/items/${item.character_item_id}/unequip?game_id=${item.game_id}`
  )
export const mutationUseCharacterItem = async (item: IUseItem) =>
  securedAxios.post(
    `/characters/${item.character_id}/items/${item.character_item_id}/use?game_id=${item.game_id}`
  )

export const mutationPassTime = async (game: IGame) =>
  securedAxios.post(`/games/${game.slug}/pass_time`)

export const mutationDmgRoll = async (char_id: number, game_id: number) =>
  securedAxios.post(`/characters/${char_id}/dmg_roll?game_id=${game_id}`)
